<template>
  <div>
    <SkeletonScreen v-if="!isCloseSkeletonScreen" :data="3" />
    <div v-if="isCloseSkeletonScreen">
      <div v-if="msg_list.length">
        <live-list-pub
          v-for="(item,index) in msg_list"
          :key="index"
          :live="item.live"
          :msg="item.msg"
          :is_vip="is_vip"
        ></live-list-pub>
      </div>
      <no-result v-if="!msg_list.length" title="此用户没有发布内容"></no-result>
      <loading
        class="loadbox"
        style="padding: 12px 0;"
        loadType="small"
        :title="'正在加载中...'"
        v-if="listLoading"
      ></loading>
      <no-data msg="已经到底了~" v-if="!listLoading&&!hasMore&&msg_list.length"></no-data>
    </div>
  </div>
</template>
<script>
import UserProfilesApi from "@/api/userProfiles/";
import LiveListPub from "@/components/appLiveListPub/";
import noData from "@/base/nodata/";
import noResult from "@/base/no-result/";

export default {
  name: "UserProfiles",
  components: {
    LiveListPub,
    noData,
    noResult
  },
  computed: {
    userInfo() {
      return this.$store.state.userProfiles.userInfo;
    }
  },
  props: {
    pageType: {
      type: String,
      default: "teacher"
    },
    view_user_id: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      msg_list: [],
      is_vip: "",
      user_id: parseInt(this.$route.params.id),
      isCloseSkeletonScreen: false,
      hasMore: true,
      listLoading: true,
      before: "",
      randomStr: Math.random()
        .toString(36)
        .slice(-4)
    };
  },
  created() {
    this.getEssenceList();
  },
  methods: {
    //获取老师个人主页  精华列表
    columnListMore() {
      if (!this.hasMore) return;
      if (this.listLoading) return;

      this.before = this.msg_list[this.msg_list.length - 1].msg.rec_time;
      this.getEssenceList();
    },
    async getEssenceList() {
      this.listLoading = true;
      let userId = this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.userId;
      let essenceList = await UserProfilesApi.getAdvisorEssenceList(
        this.user_id,
        this.before,
        userId,
        this.view_user_id
      );
      if (essenceList && essenceList.length) {
        if (this.before) {
          this.msg_list = this.msg_list.concat(essenceList);
        } else {
          this.msg_list = essenceList;
        }
        this.hasMore = true;
        this.is_vip = essenceList[0].msg.is_vip;
        this.isCloseSkeletonScreen = true;
      } else {
        this.hasMore = false;
      }
      this.listLoading = false;
      this.isCloseSkeletonScreen = true;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color-red: #fe484a; //主色
@color-red-high: #c7000a; //特殊情况
@color-green: #0ac890; //主色
@color-blue: #1d88d0; //全文、超链接颜色
@color-gray-small: #f7f7f7; //转发内容背影色

@color-gray-high: #222222;
@color-gray-middle: #636363;
@color-gray-low: #939393;

.border-1px(@color: #ccc, @radius: 0px, @style: solid) {
  position: relative;

  &::after {
    content: "";
    pointer-events: none;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: 0 0;
    border-bottom: 1px @style @color;
    border-radius: @radius;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    @media (min-resolution: 2dppx) {
      width: 200%;
      height: 200%;
      border-radius: @radius * 2;
      transform: scale(0.5);
    }

    @media (min-resolution: 3dppx) {
      width: 300%;
      height: 300%;
      border-radius: @radius * 3;
      transform: scale(0.333);
    }
  }
}

.recommend {
  position: fixed;
  overflow: auto;
  top: 48px;
  width: 100%;
  padding-bottom: 50px;
  bottom: 0;
  background-color: #f0f0f0;
}

.recommend-content {
  height: 100%;
  overflow: hidden;
}
</style>